function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "px",
    height: "56px",
    viewBox: "0 0 116 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 39.51,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 1874.107691 1698.197266 L 1631.303273 1698.197266 L 1631.303273 1051.834821 L 1874.107691 1051.834821 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 39.51,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 3188.52007 1698.197266 L 2945.871296 1698.197266 L 2945.871296 1051.834821 L 3188.52007 1051.834821 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 39.51,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 4167.831223 1698.197266 L 3925.026805 1698.197266 L 3925.026805 1051.834821 L 4167.831223 1051.834821 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 39.51,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 1633.793575 1365.458147 L 1837.687029 1365.458147 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 39.51,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 2948.361598 1365.458147 L 3152.255051 1365.458147 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 39.51,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 3927.517107 1365.458147 L 4131.41056 1365.458147 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 40.42,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 2010.918642 1698.197266 L 2223.995084 1698.197266 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 39.96,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 4593.050242 1205.538225 C 4593.050242 1120.682757 4530.170124 1051.834821 4452.815127 1051.834821 C 4375.460129 1051.834821 4319.583984 1120.682757 4319.583984 1205.538225 C 4319.583984 1248.898438 4319.895272 1310.908203 4377.172212 1350.693917 C 4436.316878 1391.878348 4492.971242 1362.039062 4545.111934 1408.818359 C 4602.855805 1460.726283 4593.050242 1544.493862 4593.050242 1544.493862 C 4593.050242 1629.34933 4530.170124 1698.352679 4452.815127 1698.352679 C 4375.460129 1698.352679 4312.580011 1629.34933 4312.580011 1544.493862 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 40.42,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 2010.918642 1051.834821 L 2010.918642 1698.197266 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 40.42,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 2349.910964 1051.834821 L 2349.910964 1698.197266 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 40.42,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 3745.725081 1051.834821 L 3745.725081 1698.197266 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 41.7,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 3575.917632 1146.636719 C 3575.917632 1094.262556 3533.426859 1051.834821 3481.130523 1051.834821 L 3338.872037 1051.834821 L 3338.872037 1365.458147 L 3481.130523 1365.458147 C 3533.426859 1365.458147 3575.917632 1322.875 3575.917632 1270.500837 Z M 3575.917632 1146.636719 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 41.61,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 3575.917632 1698.197266 L 3575.917632 1472.848493 C 3575.917632 1413.636161 3533.426859 1365.458147 3481.130523 1365.458147 L 3338.872037 1365.458147 L 3338.872037 1698.197266 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 40.42,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 2513.492659 1051.834821 L 2657.15194 1698.197266 L 2800.966864 1051.834821 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20.11,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 3525.177734 642.477121 C 3525.177734 605.799665 3495.294114 575.960379 3458.562163 575.960379 C 3421.830213 575.960379 3392.102236 605.799665 3392.102236 642.477121 L 3392.102236 789.186942 C 3392.102236 825.864397 3421.830213 855.703683 3458.562163 855.703683 C 3495.294114 855.703683 3525.177734 825.864397 3525.177734 789.186942 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20.11,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 1764.378772 642.477121 C 1764.378772 605.799665 1734.650795 575.960379 1697.918844 575.960379 C 1661.186894 575.960379 1631.303273 605.799665 1631.303273 642.477121 L 1631.303273 789.186942 C 1631.303273 825.864397 1661.186894 855.703683 1697.918844 855.703683 C 1734.650795 855.703683 1764.378772 825.864397 1764.378772 789.186942 Z M 1764.378772 642.477121 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20.11,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 4296.859981 642.477121 C 4296.859981 605.799665 4267.132004 575.960379 4230.400054 575.960379 C 4193.668103 575.960379 4163.784483 605.799665 4163.784483 642.477121 L 4163.784483 789.186942 C 4163.784483 825.864397 4193.668103 855.703683 4230.400054 855.703683 C 4267.132004 855.703683 4296.859981 825.864397 4296.859981 789.186942 Z M 4296.859981 642.477121 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20.11,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 3098.869208 575.960379 L 3098.869208 789.186942 C 3098.869208 825.864397 3128.752829 855.703683 3165.329135 855.703683 C 3202.061086 855.703683 3231.944706 825.864397 3231.944706 789.186942 L 3231.944706 575.960379 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20.11,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 2356.136719 642.477121 C 2356.136719 605.799665 2326.253098 575.960379 2289.521148 575.960379 C 2252.789197 575.960379 2226.329741 605.799665 2226.329741 642.477121 C 2226.329741 661.282087 2226.485385 688.168527 2253.567416 705.263951 C 2281.738955 723.13644 2308.509698 710.237165 2333.257072 730.440848 C 2360.806034 752.975725 2356.136719 789.186942 2356.136719 789.186942 C 2356.136719 825.864397 2326.253098 855.703683 2289.521148 855.703683 C 2252.789197 855.703683 2223.06122 825.864397 2223.06122 789.186942 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20.11,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 1933.408001 855.703683 L 1933.408001 575.960379 L 2055.277142 855.703683 L 2055.277142 575.960379 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20.11,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 4471.648033 855.703683 L 4471.648033 575.960379 L 4593.672818 855.703683 L 4593.672818 575.960379 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20.11,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 2514.270878 575.960379 L 2653.416487 575.960379 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20.11,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 3687.514278 575.960379 L 3826.659887 575.960379 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20.11,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 2583.843683 584.041853 L 2583.843683 855.703683 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20.11,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 3757.087082 584.041853 L 3757.087082 855.703683 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20.11,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 3988.99643 575.960379 L 3988.99643 855.703683 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20.11,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 2934.35365 622.42885 C 2934.35365 596.785714 2913.497373 575.960379 2887.816137 575.960379 L 2817.932045 575.960379 L 2817.932045 711.635882 L 2887.816137 711.635882 C 2913.497373 711.635882 2934.35365 690.810547 2934.35365 665.167411 Z M 2934.35365 622.42885 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 20.11,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 2934.35365 855.703683 L 2934.35365 758.104353 C 2934.35365 732.461217 2913.497373 711.635882 2887.816137 711.635882 L 2817.932045 711.635882 L 2817.932045 855.703683 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 41.67,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 0.45098,
      strokeDasharray: "4.17,95.83",
      strokeMiterlimit: 1.5
    },
    d: "M 264.750202 692.986328 L 1357.992659 461.421038 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 41.67,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 0.45098,
      strokeDasharray: "4.17,95.83",
      strokeMiterlimit: 1.5
    },
    d: "M 256.812365 1944.993025 L 1383.518252 526.38365 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 41.67,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 0.45098,
      strokeDasharray: "4.17,95.83",
      strokeMiterlimit: 1.5
    },
    d: "M 1345.852438 1055.098493 L 1434.880725 536.796317 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 54.17,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 1255.423357 1246.567243 C 1139.77997 1338.416295 993.474744 1393.277065 834.406721 1393.277065 C 498.215989 1393.277065 218.835264 1147.880022 165.916352 826.486049 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 54.17,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 165.916352 605.178013 C 218.835264 283.78404 498.215989 38.231585 834.406721 38.231585 C 1071.296673 38.231585 1280.015086 160.075335 1401.106008 344.550502 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(4.705882%,56.470588%,48.235294%)",
      fillOpacity: 1
    },
    d: "M 36.414062 8.082031 C 38.078125 8.082031 39.429688 9.433594 39.429688 11.101562 C 39.429688 12.769531 38.078125 14.121094 36.414062 14.121094 C 34.75 14.121094 33.398438 12.769531 33.398438 11.101562 C 33.398438 9.433594 34.75 8.082031 36.414062 8.082031 Z M 36.414062 9.234375 C 35.382812 9.234375 34.546875 10.070312 34.546875 11.101562 C 34.546875 12.132812 35.382812 12.96875 36.414062 12.96875 C 37.441406 12.96875 38.277344 12.132812 38.277344 11.101562 C 38.277344 10.070312 37.441406 9.234375 36.414062 9.234375 Z M 36.414062 9.234375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(4.705882%,56.470588%,48.235294%)",
      fillOpacity: 1
    },
    d: "M 33.375 26.269531 C 35.039062 26.269531 36.386719 27.621094 36.386719 29.289062 C 36.386719 30.957031 35.039062 32.308594 33.375 32.308594 C 31.710938 32.308594 30.359375 30.957031 30.359375 29.289062 C 30.359375 27.621094 31.710938 26.269531 33.375 26.269531 Z M 33.375 27.421875 C 32.34375 27.421875 31.507812 28.257812 31.507812 29.289062 C 31.507812 30.320312 32.34375 31.15625 33.375 31.15625 C 34.402344 31.15625 35.238281 30.320312 35.238281 29.289062 C 35.238281 28.257812 34.402344 27.421875 33.375 27.421875 Z M 33.375 27.421875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 54.17,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 1288.886786 1055.098493 C 1173.399044 852.440011 955.497643 715.832031 705.689251 715.832031 L 264.750202 715.832031 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 54.17,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 156.889009 826.486049 L 156.889009 1957.581473 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 54.17,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 264.750202 2070.877511 L 705.689251 2070.877511 C 1075.965989 2070.877511 1376.514278 1770.308873 1376.514278 1400.115234 L 1376.514278 1386.594308 C 1376.514278 1348.518136 1373.401401 1311.219029 1367.33129 1274.8524 ",
    transform: "matrix(0.0250974,0,0,0.0251346,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(4.705882%,56.470588%,48.235294%)",
      fillOpacity: 1
    },
    d: "M 3.9375 14.972656 C 5.601562 14.972656 6.953125 16.324219 6.953125 17.992188 C 6.953125 19.660156 5.601562 21.011719 3.9375 21.011719 C 2.273438 21.011719 0.921875 19.660156 0.921875 17.992188 C 0.921875 16.324219 2.273438 14.972656 3.9375 14.972656 Z M 3.9375 16.125 C 2.910156 16.125 2.074219 16.960938 2.074219 17.992188 C 2.074219 19.023438 2.910156 19.859375 3.9375 19.859375 C 4.96875 19.859375 5.804688 19.023438 5.804688 17.992188 C 5.804688 16.960938 4.96875 16.125 3.9375 16.125 Z M 3.9375 16.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(4.705882%,56.470588%,48.235294%)",
      fillOpacity: 1
    },
    d: "M 3.9375 49.03125 C 5.601562 49.03125 6.953125 50.382812 6.953125 52.050781 C 6.953125 53.71875 5.601562 55.070312 3.9375 55.070312 C 2.273438 55.070312 0.921875 53.71875 0.921875 52.050781 C 0.921875 50.382812 2.273438 49.03125 3.9375 49.03125 Z M 3.9375 50.183594 C 2.910156 50.183594 2.074219 51.019531 2.074219 52.050781 C 2.074219 53.082031 2.910156 53.917969 3.9375 53.917969 C 4.96875 53.917969 5.804688 53.082031 5.804688 52.050781 C 5.804688 51.019531 4.96875 50.183594 3.9375 50.183594 Z M 3.9375 50.183594 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/LogoFull.20d31bdb5c29258e8c60a16811b7e2e7.svg";
export { ForwardRef as ReactComponent };